export default __webpack_public_path__ + "static/media/turista-atardecer-barco-lago.fd3e0309.jpeg";